/**
 * Created by Christof Sander on 29.01.2017.
 */

const utils = require('frontend-controller/lib/utils');

module.exports = {
	config: {
		environmentDependent: true
	},

	model: {
		active: null,
		windowIndexOffset: 0,
		dynamicProperties: {}
	},

	methods: {
		/**
		 * this function has to return true if the environment dependent refresh should be performed.
		 *
		 * @param   activeEnvironment               {} - active environment
		 * @param   newEnvironment                  {} - new environment
		 * @param   serverKnownEnvironment          {} - environment known by the server
		 * @param   initialExecution                boolean - is this the initial execution
		 * @param   externalDrivenCall              boolean - e.g., browser resize -> true, ibt-grid-style-change -> false
		 * @param   environmentUpdateByParent       boolean - has a parent of mine decided to refresh and already updated by own activeEnvironment
		 * @returns boolean
		 */
		environmentRefreshNecessary: function(activeEnvironment, newEnvironment, serverKnownEnvironment, initialExecution, externalDrivenCall, environmentUpdateByParent){

			// refresh some internal states
			this.model.styleChanged                     = newEnvironment.style != activeEnvironment.style;
			this.model.breakPointChangedToBigggerOne    = activeEnvironment.breakPoint != newEnvironment.breakPoint && activeEnvironment.breakPointSize < newEnvironment.breakPointSize;

			var newActiveState = (
				(this.model.showOnDesktop && newEnvironment.style == 'desktop')
				||
				(this.model.showOnMobile && newEnvironment.style == 'mobile')
			);

			// ignore dom of this element
			if(this.model.active !== newActiveState){
				this.model.active = newActiveState;
				this.model.activeStateChanged = true;
			}
			else {
				this.model.activeStateChanged = false;
			}

			// refresh reasons
			return (
				this.model.styleChanged ||
				this.model.activeStateChanged ||
				this.model.breakPointChangedToBigggerOne
			);
		},

		/**
		 * this function will be called after all environment dependent components had the change to decide if they want
		 * to be refreshed or not. further more this function will be called after the new environment has been set as
		 * activeEnvironment.
		 */
		onEnvironmentUpdated: function(){
			if(this.model.styleChanged || this.model.activeStateChanged){
				this.refreshDynamicState();
					this.model.columnComponent.onWindowUpdate(true);
			}
			else {
				this.model.columnComponent.onWindowUpdate();
			}
		},

		refreshDynamicState: function(){
			if(this.model.isDynamic && typeof(this.model.childComponent.getWindowParameters) == 'function'){
				this.model.dynamicProperties = this.model.childComponent.getWindowParameters(this.activeEnvironment);
			}
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!options.refresh){
				if(this.model.isDynamic){
					this.find(undefined, function(firstChildComponent){
						self.model.childComponent = firstChildComponent;
						return 'break';
					});
				}
				this.closest('layouts_column_column', function(columnComponent){
					self.model.columnComponent = columnComponent;
				});
			}
		}
	}
};
